<template>
  <Modal
    title="注单列表"
    v-model="modalstate"
    :transfer="false"
    class-name="vertical-center-modal"
    width="70%"
  >
    <lida-table :propscolumns="column" :data="getliveshow.moddata" :propsPageSize="50"></lida-table>
    <div slot="footer">
      <Button type="primary" @click="chg_liveshow_state({ modal_show: false })">关闭</Button>
    </div>
  </Modal>
</template>

<script>
import { log } from "util";
import { mapGetters, mapActions } from "vuex";
import checkpath from "@/views/liveshow/mixins/checkPath";
export default {
  name: "modal-betting-list",
  mixins: [checkpath],
  data () {
    return {
      modalCanre: {
        status: false,
        id: null,
        reason: '会员要求取消',
        canre: null,
      },
      columnDefault: {
        id: {
          title: '補貨ID',
          key: 'id',
          align: 'center'
        },
        mark: {
          title: '投注选项',
          key: 'mark',
          align: 'center',
          render: (h, params) => 
            params.row.mark != '' 
              ? h('p', `${params.row.deoddsrepname}-${params.row.mark}`) 
              : null
        },
        username: {
          title: '帐号',
          key: 'username',
          align: 'center'
        },
        date: {
          title: '时间',
          key: 'date',
          align: 'center',
          totaltext: '总计',
          notetext: '小计'
        },
        value: {
          title: '下注金额',
          key: 'value',
          align: 'center',
          total: true,
          note: true
        },
        odds: {
          title: '赔率',
          key: 'odds',
          align: 'center'
        },
        duishei: {
          title: '退水',
          key: 'duishei',
          align: 'center',
          render: (h, params) => 
            params.row.duishei != '' 
              ? h('p', `${params.row.duishei}%`)
              : null
        },
        bpname: {
          title: '盘口',
          key: 'bpname',
          align: 'center'
        },
        ltl: {
          title: '占成金额',
          key: 'ltl',
          align: 'center',
          total: true,
          note: true,
          render: (h, params) => h('p', Math.round(params.row.ltl))
        },
        betispo: {
          title: '补货',
          key: 'betispo',
          align: 'center',
          render: (h, params) => 
            params.row.betispo != '' 
              ? h('p', 'o')
              : null
          
        },
        betst: {
          title: '下注状况',
          key: 'betst',
          align: 'center',
          render: (h, params) => {
            let result
            switch (params.row.betst) {
              case '1':
                result = '已确认'
                break;
              case '0':
                result = '已结算'
                break;
              case '-1':
                result = '已注销'
                break;
            }
            return h('p', result)
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getliveshow", "getmember"]),
    modalstate: {
      get () {
        return this.getliveshow.modal_show
      },
      set (val) {
        this.chg_liveshow_state({ modal_show: val })
      }
    },
    column () {
      return this.columnDefault
    }
  },
  methods: {
    ...mapActions(["chg_liveshow_state"]),
    NotThat (value) {
      return ['总计', '小计', '本占比总计'].some(it => it != value)
    }
  }
};
</script>